<template>
	<div :class="['watcher', { 'is-mobile': isMobile }]">
		<section ref="sec1" class="section-1" :style="{height}">
			<h3 class="title textfade textfade1">{{ text.first.title }}</h3>
			<p class="text textfade textfade2">{{ text.first.text }}</p>
			<img src="../assets/image/watcher/mobile/p1-pic.jpg" alt="" srcset="">
		</section>
		<section
			ref="sec2"
			class="section-2 clearfix"
			@mouseleave="leave(true)"
		>
			<div @mouseenter="enter" @mouseleave="leave">
				<picture>
					<source
						srcset="../assets/image/watcher/mobile/dianwang.png"
						media="(max-width: 600px)"
					/>
					<img
						src="../assets/image/watcher/dianwang-min.jpg"
						alt=""
					/>
				</picture>
				<div class="tips">
					<div class="bg"></div>
					<h4 class="title"><b v-html="isMobile ? text.second[0].title[1]: text.second[0].title[0]"></b><i class="play-btn" v-if="!isMobile" @click="handlePlay(true)"></i></h4>
					<span class="txt textfade">{{ text.second[0].text }}</span>
				</div>
			</div>
			<div @mouseenter="enter" @mouseleave="leave">
				<picture>
					<source
						srcset="../assets/image/watcher/mobile/guandao.png"
						media="(max-width: 600px)"
					/>
					<img src="../assets/image/watcher/guandao-min.jpg" alt="" />
				</picture>
				<div class="tips">
					<div class="bg"></div>
					<h4 class="title">{{ text.second[1].title }}</h4>
					<span class="txt textfade">{{ text.second[1].text }}</span>
				</div>
			</div>
			<div @mouseenter="enter" @mouseleave="leave">
				<picture>
					<source
						srcset="../assets/image/watcher/mobile/gaosu.png"
						media="(max-width: 600px)"
					/>
					<img src="../assets/image/watcher/gaosu-min.jpg" alt="" />
				</picture>
				<div class="tips">
					<div class="bg"></div>
					<h4 class="title">{{ text.second[2].title }}</h4>
					<span class="txt textfade">{{ text.second[2].text }}</span>
				</div>
			</div>
			<div @mouseenter="enter" @mouseleave="leave">
				<picture>
					<source
						srcset="../assets/image/watcher/mobile/hangdao.png"
						media="(max-width: 600px)"
					/>
					<img src="../assets/image/watcher/hangdao-min.jpg" alt="" />
				</picture>
				<div class="tips">
					<div class="bg"></div>
					<h4 class="title">{{ text.second[3].title }}</h4>
					<span class="txt textfade">{{ text.second[3].text }}</span>
				</div>
			</div>
		</section>
		<section ref="sec3" :class="['section-3', { active: showSec3 }]">
			<h3 :class="['title', 'textfade', { textfade1: showSec3 }]">
				{{ text.third.title }}
			</h3>
			<p :class="['text', 'textfade', { textfade2: showSec3 }]">
				{{ text.third.text }}
			</p>
			<div :class="['pictures', { active: airplaneAnimate }]">
				<img
					class="plane"
					src="../assets/image/watcher/M300.png"
					alt=""
					srcset=""
				/>
				<img
					class="main"
					src="../assets/image/watcher/airport-nodoor.png"
					alt=""
					srcset=""
				/>
				<img
					class="bar"
					src="../assets/image/watcher/airport-bar.png"
					alt=""
					srcset=""
				/>
				<img
					class="light"
					src="../assets/image/watcher/airport-light.png"
					alt=""
					srcset=""
				/>
				<img
					class="airport"
					src="../assets/image/watcher/airport-door.png"
					alt=""
					srcset=""
				/>
			</div>
		</section>
		<section ref="sec4" :class="['section-4']">
			<h3 :class="['title', 'textfade', { textfade1: showSec4 }]">
				{{ text.forth.title }}
			</h3>
			<p :class="['text', 'textfade', { textfade2: showSec4 }]">
				{{ text.forth.text }}
			</p>
			<div class="pictures">
				<picture>
					<source srcset="../assets/image/watcher/mobile/mechanical-arm.jpg"	media="(max-width: 600px)">
					<img src="../assets/image/watcher/mechanical-arm.jpg" alt="机械臂">
				</picture>
				<video 
					v-if="!isMobile" 
					ref="video" 
					muted 
					preload  
					autoplay
					loop
					playsinline
					x5-video-player-type="h5-page"
					src="../assets/image/watcher/out4_2.mp4"></video>
			</div>
		</section>
		<section ref="sec5" :class="['section-5']">
			<div class="title-wrap">
				<h3 :class="['title', 'textfade', { textfade1: showSec5 }]">
				{{ text.fifth.title }}
			</h3>
			<p :class="['text', 'textfade', { textfade2: showSec5 }]">
				{{ text.fifth.text }}
			</p>
			</div>
			<img v-if="isMobile" src="../assets/image/watcher/mobile/map.jpg" alt="">
		</section>
		<section ref="sec6" :class="['section-6']">
			<h3 :class="['title', 'textfade', { textfade1: showSec6 }]">
				{{ text.sixth.title }}
			</h3>
			<p :class="['text', 'textfade', { textfade2: showSec6 }]">
				{{ text.sixth.text }}
			</p>
			<ul :class="['features', 'textfade', { textfade3: showSec6 }]">
				<li v-for="item in text.sixth.tips" :key="item">{{item}}</li>
			</ul>
		</section>
		<section ref="sec7" :class="['section-7', { active: showSec7 }]">
			<div class="static">
				<h3 :class="['title', 'textfade', { textfade1: showSec7 }]">
					{{ text.seventh.title }}
				</h3>
				<p :class="['text', 'textfade', { textfade2: showSec7 }]">
					{{ text.seventh.text }}
				</p>
				<picture>
					<source
						srcset="../assets/image/watcher/mobile/SAAS.png"
						media="(max-width: 600px)"
					/>
					<img
						class="saas"
						src="../assets/image/watcher/SAAS-mini.png"
						alt=""
					/>
				</picture>
				<picture>
					<source
						srcset="../assets/image/watcher/mobile/white-m210.png"
						media="(max-width: 600px)"
					/>
					<img
						class="m210"
						src="../assets/image/watcher/white-m210.png"
						alt=""
					/>
				</picture>
			</div>
			<picture>
				<source
					v-if="$route.params.lang === 'EN'"
					srcset="../assets/image/watcher/mobile/p4-en.png"
					media="(max-width: 600px)"
				/>
				<source
					v-else
					srcset="../assets/image/watcher/mobile/p4.png"
					media="(max-width: 600px)"
				/>
				<img
					class="base-pic"
					src="../assets/image/watcher/p4.png"
					alt=""
				/>
			</picture>
			<picture>
				<source
					v-if="$route.params.lang === 'EN'"
					srcset="../assets/image/watcher/mobile/dash-line-en.png"
					media="(max-width: 600px)"
				/>
				<source
					v-else
					srcset="../assets/image/watcher/mobile/dash-line.png"
					media="(max-width: 600px)"
				/>
				<img
					class="dash-line"
					src="../assets/image/watcher/dash-line.png"
					alt=""
				/>
			</picture>
		</section>
		<section ref="sec8" class="section-8">
			<h3 :class="['title', 'textfade', { textfade1: showSec8 }]">
				{{ text.eighth.title }}
			</h3>
			<p :class="['text', 'textfade', { textfade2: showSec8 }]">
				{{ text.eighth.text }}
			</p>
			<picture>
				<source
					srcset="../assets/image/watcher/mobile/p5.png"
					media="(max-width: 600px)"
				/>
				<img src="../assets/image/watcher/p5.png" alt="" />
			</picture>
		</section>
		<section ref="sec9" :class="['section-9', { active: showSec9 }]">
			<div class="sec9-wrap">
				<h3 :class="['title', 'textfade', { textfade1: showSec9 }]">
					{{ text.ninth.title }}
				</h3>
				<p :class="['text', 'textfade', { textfade2: showSec9 }]">
					{{ text.ninth.text }}
				</p>
				<div class="img-wrap">
					<picture>
						<source
							srcset="../assets/image/watcher/mobile/p6.png"
							media="(max-width: 600px)"
						/>
						<img src="../assets/image/watcher/p6.png" alt="" />
					</picture>
					<div class="border">
						<img src="../assets/image/watcher/elec.png" alt="" />
					</div>
					<div class="border">
						<img src="../assets/image/watcher/pipe.png" alt="" />
					</div>
					<div class="border">
						<img src="../assets/image/watcher/road.png" alt="" />
					</div>
					<div class="border">
						<img src="../assets/image/watcher/ship.png" alt="" />
					</div>
				</div>
			</div>
		</section>
		<params
			:params="text.parmas"
			id="sec10"
		></params>
		<foot></foot>
		<div class="video-mask" v-if="showVideo && !isMobile">
			<div :class="['video-wrap', {replay}]">
				<i class="close-btn" @click="handlePlay(false)"></i>
				<i v-if="replay" class="replay-btn" @click="handleReplay"></i>
				<video 
					ref="videoXunXian"
					muted 
					preload
					autoplay
					playsinline
					controls
					@ended="handleEnded"
					controlslist="nodownload noremoteplayback"
					x5-video-player-type="h5-page"
					class="video" 
					src="../assets/image/watcher/dianlixunxian.mp4"></video>
				</div>
		</div>
	</div>
</template>
<script>
import { isMobile } from '@/js/utils';
import { catcher } from '@/js/text';
import { mapState, mapMutations } from 'vuex';

export default {
	name: 'catcher',
	metaInfo: {
		meta: [
			{
				name: 'keywords',
				content:
					'无人机, 自动机场, 电力, 石油管道, 航道,组网,监控,  AI, 深度学习, 定点巡航,守望者,云端Saas,航道巡检巡逻,高速巡逻,管道巡检,电网巡检'
			},
			{
				name: 'description',
				content:
					'守望者是一套固定式无人机全自动飞行系统，主要用于对大范围固定场所高频次采样测量，一次部署自动运行，配合云端SaaS系统的智能分析，提高对巡查范围的数据分析效率。广泛应用于线路巡检、河床淤泥治理及重点场所勘查等场景.'
			}
		]
	},
	data() {
		return {
			isMobile: false,
			showSec3: false,
			showSec4: false,
			showSec5: false,
			showSec6: false,
			showSec7: false,
			showSec8: false,
			showSec9: false,
			airplaneAnimate: false,
			height: '100vh',
			scrollAble: true,
			showFoot: false,
			wheelTimer: 0,
			maxScrollTop: 0,
			changeAble: false,
			isMin: false,
			transferTimer: null,
			resized: true,
			heights: null,
			showVideo: false,
			replay: false
		};
	},
	components: {
		Foot: () => import('@/components/footer.vue'),
		Params: () => import('@/components/params-observer.vue')
	},
	computed: {
		...mapState(['headerStyle']),
		text() {
			return this.$route.params.lang === 'CN' ? catcher.CN : catcher.EN;
		}
	},
	methods: {
		...mapMutations(['setHeaderStyle']),
		enter(e) {
			clearTimeout(this.transferTimer);
			let child = Array.from(this.$refs.sec2.childNodes);
			child.forEach(n => {
				this.transferTimer = setTimeout(() => {
					n.classList.remove('normal');
					n.classList.remove('max');
					n.classList.remove('min');
					if (e.target === n) {
						n.classList.add('max');
					} else {
						n.classList.add('min');
					}
				}, 90);
			});
		},
		leave(e) {
			let child = Array.from(this.$refs.sec2.childNodes);
			if (typeof e === 'boolean') {
				clearTimeout(this.transferTimer);
				setTimeout(() => {
					child.forEach(n => {
						n.classList.remove('max');
						n.classList.remove('min');
						n.classList.remove('normal');
					});
				}, 90);
			}
			child.forEach(n => {
				n.classList.remove('max');
				n.classList.remove('min');
				n.classList.add('normal');
			});
		},
		handlePlay(b) {
			this.showVideo = b;
			if(b) {
				document.body.style.overflow = 'hidden'
				this.$nextTick(() => {
					this.$refs.videoXunXian["disablePictureInPicture"] = true
				})
			}else {
				this.replay = false
				document.body.style.overflow = 'auto'
			}
		},
		handleEnded() {
			this.replay = true
		},
		handleReplay() {
			this.replay = false
			this.$refs.videoXunXian.play()
		},
		resetAnimate() {
			this.showSec3 = false;
			this.showSec7 = false;
			this.airplaneAnimate = false;
			this.showSec8 = false;
			this.showSec9 = false;
			this.swiper.autoHeight = false;
		},
		resize() {
			this.isMobile = window.innerWidth <= 600 || isMobile();
			this.isMin = window.innerWidth / window.innerHeight > 0.57 && this.isMobile;
			this.resized = true
		},
		getHeight() {			
			let scrollHeight =
				document.documentElement.scrollHeight ||
				document.body.scrollHeight;
			let h1 = this.$refs.sec1.offsetHeight;
			let h2 = this.$refs.sec2.offsetHeight;
			let h3 = this.$refs.sec3.offsetHeight;
			let h4 = this.$refs.sec4.offsetHeight;
			let h5 = this.$refs.sec5.offsetHeight;
			let h6 = this.$refs.sec6.offsetHeight;
			let h7 = this.$refs.sec7.offsetHeight;
			let h8 = this.$refs.sec8.offsetHeight;
			let h9 = this.$refs.sec9.offsetHeight;
			let h10 = document.getElementById('sec10').offsetHeight;
			return { scrollHeight, h1, h2, h3, h4, h5, h6, h7, h8, h9, h10 }
		},
		initEvent() {
			if(this.resized) {
				this.heights = this.getHeight()
				this.resized = false
			}
			let scrollTop =	document.documentElement.scrollTop || document.body.scrollTop;
			let { scrollHeight, h1, h2, h3, h4, h5, h6, h7, h8, h9, h10 } = this.heights

			if (!this.isMobile) {
				if (
					scrollTop < h1 + h2 ||
					(scrollTop >= h1 + h2 + h3 - 40 &&
						scrollTop < h1 + h2 + h3 + h4 - 40) || 
					scrollTop >= h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9 + h10 - 40
				) {
					this.setHeaderStyle({ headerStyle: 'light' });
				}
				if (
					(scrollTop > h1 + h2 - 40 &&
						scrollTop < h1 + h2 + h3 - 40) ||
					(scrollTop >= h1 + h2 + h3 + h4 - 40 &&
						scrollTop < h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9 + h10 - 40)
				) {
					this.setHeaderStyle({ headerStyle: 'dark' });
				}
			}
			if (scrollTop > h1 + h2 * 0.2) {
				this.showSec3 = true;
			}
			if (scrollTop > h1 + h2 + h3 * 0.2) {
				if(!this.showSec4 && !this.isMobile) {
					this.$refs.video.play()
				}
				this.showSec4 = true;
			}
			if (scrollTop > h1 + h2 + h3 + h4 * 0.2) {
				this.showSec5 = true;
			}
			if (scrollTop > h1 + h2 + h3 + h4 + h5 * 0.2) {
				this.showSec6 = true;
			}
			if (scrollTop > h1 + h2 + h3 + h4 + h5 + h6 * 0.2) {
				this.showSec7 = true;
			}
			if (scrollTop > h1 + h2 + h3 + h4 + h5 + h6 + h7 * 0.2) {
				this.showSec8 = true;
			}
			if (scrollTop > h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 * 0.2) {
				this.showSec9 = true;
			}
		}
	},
	mounted() {
		this.setHeaderStyle({ headerStyle: 'light' });
		this.isMobile = window.innerWidth <= 600 || isMobile();
		this.isMin =
			window.innerWidth / window.innerHeight > 0.57 &&
			devicePixelRatio < 3 &&
			this.isMobile;
		if (this.isMobile) {
			this.$nextTick(() => {
				this.height = this.$refs.sec1.offsetHeight + 'px';
			});
		}
		window.addEventListener('resize', this.resize);
		window.addEventListener('scroll', this.initEvent);
	},
	beforeDestroy() {
		window.onscroll = null;
		this.$refs.video && this.$refs.video.pause();
		document.body.style.overflow = 'auto'
		clearInterval(this.wheelTimer);
		window.removeEventListener('resize', this.resize);
		window.removeEventListener('scroll', this.initEvent);
	}
};
</script>
<style lang="scss">
@import '../assets/css/watcher.scss';
</style>
